export const convertObjectURLInFormData = async (url) => {
  const blob = await fetch(url).then((r) => r.blob());

  const formData = new FormData();

  formData.append('image', blob, `${blob.name}`);

  return formData;
};
